import React, { useContext } from "react";
import Text from "../components/shared/components/Text";
import person from "../assets/summary/icons-theme/id-video.svg";
import id_card from "../assets/summary/icons-theme/id-front.svg";
import account_balance from "../assets/summary/icons-theme/data-duo.svg";
import payments from "../assets/summary/icons-theme/hand-coin.svg";
import { Typography } from "@material-ui/core";
import { assetIds } from "nemuru-components";
import { ConfigContext } from "../contexts/ConfigContext";

export const LENDER_APPROVAL_STATUS = {
  YES: "yes",
  NO: "no",
  MAYBE: "maybe",
};

export const LOAN_APPLICATION_STATE = {
  SELECTED: "selected",
  PROCESSED: "processed",
  NOT_PROCESSED: "not_processed",
};

export const LOAN_STATUS = {
  STATUS_INITIAL: "status_initial",
  STATUS_ANALYSING: "status_analysing",
  STATUS_LENDER_HAS_BEEN_SELECTED: "status_lender_has_been_selected",
  STATUS_CONTRACT_SIGNED: "status_contract_signed",
  STATUS_DOCS_APPROVED: "status_docs_approved",
  STATUS_ACTIVE_TRIAL: "status_active_trial",
  STATUS_ACTIVE: "status_active",
  STATUS_DENIED: "status_denied",
  STATUS_DESISTED: "status_desisted",
  STATUS_CANCELLED: "status_cancelled",
  STATUS_CANCELLED_TEST: "status_cancelled_test",
  STATUS_EXPIRED: "status_expired",
};

export const SECTIONS = {
  LOAN_CONDITIONS: {
    id: "LOAN_CONDITIONS",
    nameTextId: "SECTION_LOAN_CONDITIONS",
    titleIconName: assetIds.ICON_LOAN_ADJUST,
    icon: person,
    iconName: "person",
    endOKMessageTextId: "END_SECTION_LOAN_CONDITIONS",
    startButtonTextId: "RESUME",
    description: "QUOTA_SELECTION",
  },
  IDENTIFICATION: {
    id: "IDENTIFICATION",
    nameTextId: "SECTION_IDENTIFICATION",
    titleIconName: assetIds.ICON_ID_FACE,
    icon: person,
    iconName: "person",
    endOKMessageTextId: "END_SECTION_IDENTIFICATION",
    startButtonTextId: "CHECK_ID",
    description: "ID_CHECK",
  },
  FINANCES: {
    id: "FINANCES",
    nameTextId: "SECTION_FINANCES",
    titleIconName: assetIds.ICON_BANK_SECURE,
    icon: account_balance,
    iconName: "account_balance",
    endOKMessageTextId: "END_SECTION_FINANCES",
    startButtonTextId: "RESUME",
    description: "PROFESSIONAL_AND_FINANCIAL_DATA",
  },
  SUMMARY: {
    id: "SUMMARY",
    nameTextId: "SECTION_SUMMARY",
    titleIconName: assetIds.ICON_LOAN,
    icon: payments,
    iconName: "payments",
    endOKMessageTextId: "END_SECTION_SUMMARY",
    startButtonTextId: "RESUME",
    description: "LOAN_ADJUSTMENT_AND_EVALUATION",
  },
  DOCUMENTATION_AND_SIGNATURE: {
    id: "DOCUMENTATION_AND_SIGNATURE",
    nameTextId: "SECTION_DOCUMENTATION_AND_SIGNATURE",
    titleIconName: assetIds.ICON_DOC_SIGNATURE,
    icon: id_card,
    iconName: "draw",
    endOKMessageTextId: "END_SECTION_DOCUMENTATION_AND_SIGNATURE",
    startButtonTextId: "RESUME",
    description: "UPLOAD_DOCUMENTATION_AND_SIGN",
  },
  DOCUMENTATION: {
    id: "DOCUMENTATION",
    nameTextId: "SECTION_DOCUMENTATION",
    titleIconName: assetIds.ICON_CLOUD_UPLOAD,
    icon: id_card,
    iconName: "description",
    endOKMessageTextId: "END_SECTION_DOCUMENTATION",
    startButtonTextId: "RESUME",
    description: "UPLOAD_DOCUMENTATION",
  },
  SIGNATURE: {
    id: "SIGNATURE",
    nameTextId: "SECTION_SIGNATURE",
    titleIconName: assetIds.ICON_DOC_SIGNATURE,
    icon: id_card,
    iconName: "draw",
    endOKMessageTextId: "END_SECTION_SIGNATURE",
    startButtonTextId: "RESUME",
    description: "SIGN",
  },
};

export const logicalOps = {
  AND: "and",
  OR: "or",
};

export const oKBehaviours = {
  REPEAT: "repeat",
  NEXT_FLOW_ITEM: "nextFlowItem",
  RESET_FLOW: "resetFlow",
};

export const relationalOps = {
  EXISTS: "exists",
  NOT_EXISTS: "not_exists",
  EQUAL_TO: "equalTo",
  NOT_EQUAL_TO: "notEqualTo",
  GREATER_THAN: "greaterThan",
  LESS_THAN: "lessThan",
};

export const imageConfigValues = {
  IMAGE_MAX_PIXEL_WIDTH_OR_HEIGHT: 1800,
  IMAGE_MIN_FINAL_WIDTH: 849, // unnax min pix (849w*566h=480534)
  IMAGE_CROPPER_WIDTH: 450,
};

export const ICON_TITLE_HEIGHT = 60;

export const LIST_OF_COUNTRIES_IN_PRODUCTION = {
  SPAIN: "SPAIN",
};

export const CURRENT_COUNTRY_IN_PRODUCTION =
  LIST_OF_COUNTRIES_IN_PRODUCTION.SPAIN;

export const COUNTRY_SPECIFIC_REQUIREMENTS = {
  SPAIN: {
    countryId: "ES",
    iban: {
      message: <Text tId={"INVALID_SPANISH_IBAN"} />,
    },
    address: {
      label: (
        <>
          <Text tId={"ADDRESS"} />{" "}
          <Typography variant="caption">
            <Text tId={"IN_SPAIN"} />
          </Typography>
        </>
      ),
      confirmationDialogError: (
        <>
          <Text tId="ADDRESS_DIALOG_ERROR_MESSAGE" />
          <p />
          <Text tId="ADDRESS_DIALOG_SPANISH_ADDRESS_REMINDER" />
        </>
      ),
    },
  },
};
const CUSTOM_CONFIG_BY_THEME = {
  DEFAULT: {
    minQuota: 30,
    allowTrueOptInsGoFalse: true,
  },
  caixabank: {
    minQuota: 20,
    allowTrueOptInsGoFalse: false,
  },
  ktuin: {
    minQuota: 0,
    allowTrueOptInsGoFalse: true,
  },
};
export const getCustomConfigByAppTheme = () => {
  const {
    state: { themeName },
  } = useContext(ConfigContext);
  return CUSTOM_CONFIG_BY_THEME[themeName] || CUSTOM_CONFIG_BY_THEME.DEFAULT;
};

export const RANGE_TYPES = {
  PERIOD: "period",
  PRINCIPAL: "principal",
};

export const Program = {
  FREE_PROGRAM: "free_program",
  ZERO_PROGRAM: "zero_program",
  NO_PURCHASE: "no_purchase",
};

export const LOCAL_STORAGE_KEY = {
  LOAN_ID: "loanId",
};
